// 统计分析模块页面级国际化
export default {
  // ── 通用 ──────────────────────────────────────────────
  'pages.analysis.enabled': '启用',
  'pages.analysis.disabled': '禁用',
  'pages.analysis.total': '总记录数',
  'pages.analysis.export': '导出',
  'pages.analysis.view': '查看',
  'pages.analysis.more': '更多',
  'pages.analysis.collapse': '收起',
  'pages.analysis.queryCondition': '查询条件',
  'pages.analysis.filterCondition': '筛选条件',
  'pages.analysis.exportLoading': '正在获取导出数据，请稍候…',
  'pages.analysis.exportFetchError': '获取导出数据失败',
  'pages.analysis.exportNoData': '暂无数据可导出',
  'pages.analysis.exportSuccess': '导出成功',
  'pages.analysis.exportFailed': '导出失败，请重试',
  'pages.analysis.generatedAt': '生成时间：',
  'pages.analysis.exportFailedSimple': '导出失败',
  'pages.analysis.exportOptionExcel': 'Excel (.xlsx)',
  'pages.analysis.exportOptionCsv': 'CSV (.csv)',
  'pages.analysis.exportOptionPdf': 'PDF (.pdf)',
  'pages.analysis.range.to': '至',
  'pages.analysis.range.from': '起',
  'pages.analysis.range.all': '全部',
  'pages.analysis.search.placeholderKeyword': '请输入关键词(账号/昵称/公司/部门)',
  'pages.analysis.search.placeholderUser': '请输入用户账号/昵称',
  'pages.analysis.search.placeholderUserAccount': '请输入用户账号',
  'pages.analysis.search.placeholderCompany': '请选择公司',
  'pages.analysis.search.placeholderDepartment': '请选择部门',
  'pages.analysis.search.placeholderCompanyInput': '请输入所属公司',
  'pages.analysis.search.placeholderDepartmentInput': '请输入所属部门',
  'pages.analysis.search.placeholderRole': '请选择角色',

  // ── 通用字段标签 ────────────────────────────────────────
  'pages.analysis.field.userId': '用户ID',
  'pages.analysis.field.userAccount': '用户账号',
  'pages.analysis.field.userNickname': '用户姓名',
  'pages.analysis.field.company': '所属公司',
  'pages.analysis.field.department': '所属部门',
  'pages.analysis.field.role': '角色',
  'pages.analysis.field.status': '状态',
  'pages.analysis.field.createTime': '创建时间',
  'pages.analysis.field.updateTime': '最后更新时间',
  'pages.analysis.field.app': '应用',
  'pages.analysis.field.appId': '应用ID',
  'pages.analysis.field.appName': '应用名称',
  'pages.analysis.field.appType': '应用类型',
  'pages.analysis.field.appStatus': '应用状态',
  'pages.analysis.field.appCreator': '应用创建者',
  'pages.analysis.field.tokenUsed': 'Token消耗',
  'pages.analysis.field.userCount': '使用人数',
  'pages.analysis.field.operation': '操作',
  'pages.analysis.field.unionQuery': '联合查询',
  'pages.analysis.field.user': '用户',
  'pages.analysis.field.terminal': '终端',
  'pages.analysis.field.accessTime': '访问时间',
  'pages.analysis.field.terminalAdmin': '管理后台',
  'pages.analysis.field.terminalApp': '应用中心',
  'pages.analysis.field.modelSource': '模型来源',
  'pages.analysis.field.inputTokens': '输入Token',
  'pages.analysis.field.outputTokens': '输出Token',
  'pages.analysis.field.rawTokens': '原始Token',
  'pages.analysis.field.tokenTotal': 'Token总消耗',
  'pages.analysis.field.creator': '创建人',
  'pages.analysis.field.updater': '最后更新人',
  'pages.analysis.field.email': '电子邮箱',
  'pages.analysis.field.featureTree': '功能树',
  'pages.analysis.field.permCode': '权限码',
  'pages.analysis.field.featurePerm': '功能权限',

  // ── 应用访问统计 (access/app) ────────────────────────────
  'pages.analysis.accessApp.statusActive': '启用中',
  'pages.analysis.accessApp.statusInactive': '未启用',
  'pages.analysis.accessApp.placeholderApp': '请选择应用',
  'pages.analysis.accessApp.reportTitle': '应用访问统计',

  // ── 应用访问详情 (access/app/detail) ────────────────────
  'pages.analysis.accessAppDetail.title': '应用访问详情',
  'pages.analysis.accessAppDetail.useTime': '使用时间',
  'pages.analysis.accessAppDetail.appDesc': '应用描述',
  'pages.analysis.accessAppDetail.appInfo': '应用信息',
  'pages.analysis.accessAppDetail.accessLog': '访问日志',

  // ── 菜单操作报表 (access/action) ────────────────────────
  'pages.analysis.accessAction.actionId': '操作ID',
  'pages.analysis.accessAction.actionMenu': '操作菜单',
  'pages.analysis.accessAction.type': '类型',
  'pages.analysis.accessAction.menuType': '菜单',
  'pages.analysis.accessAction.buttonType': '按钮',
  'pages.analysis.accessAction.operationTime': '操作时间',
  'pages.analysis.accessAction.actionRecord': '操作记录',
  'pages.analysis.accessAction.reportTitle': '菜单操作报表',

  // ── 系统访问报表 (access/login) ─────────────────────────
  'pages.analysis.accessLogin.account': '账号',
  'pages.analysis.accessLogin.nickname': '昵称',
  'pages.analysis.accessLogin.company': '公司',
  'pages.analysis.accessLogin.loginDateTime': '登录日期时间',
  'pages.analysis.accessLogin.logoutDateTime': '登出日期时间',
  'pages.analysis.accessLogin.loginIp': '登录IP',
  'pages.analysis.accessLogin.duration': '持续时间',
  'pages.analysis.accessLogin.loginSuccess': '登录成功',
  'pages.analysis.accessLogin.loginFailed': '登录失败',
  'pages.analysis.accessLogin.loginTime': '登录时间',
  'pages.analysis.accessLogin.logoutTime': '登出时间',
  'pages.analysis.accessLogin.loginRecord': '登录记录',
  'pages.analysis.accessLogin.reportTitle': '系统访问报表',
  'pages.analysis.accessLogin.minuteUnit': '分钟',
  'pages.analysis.accessLogin.chartDuration': '访问时长（分钟）',

  // ── 应用访问权限报表 (audit/app) ────────────────────────
  'pages.analysis.auditApp.title': '应用访问权限报表',
  'pages.analysis.auditApp.pleaseSelectApp': '请先选择应用',
  'pages.analysis.auditApp.permData': '权限数据',

  // ── 用户权限报表 (audit/user) ────────────────────────────
  'pages.analysis.auditUser.title': '用户权限报表',
  'pages.analysis.auditUser.pleaseSelectUser': '请选择用户',
  'pages.analysis.auditUser.queryFailed': '查询失败',
  'pages.analysis.auditUser.btnQuery': '查',
  'pages.analysis.auditUser.btnEdit': '改',
  'pages.analysis.auditUser.btnDelete': '删',
  'pages.analysis.auditUser.btnAdd': '增',
  'pages.analysis.auditUser.btnExport': '导出',
  'pages.analysis.auditUser.btnPrint': '打印',
  'pages.analysis.auditUser.searchPlaceholder': '输入菜单名称或路径搜索',
  'pages.analysis.auditUser.userInfo': '用户信息',

  // ── 角色授权报表 (audit/role-assign) ────────────────────
  'pages.analysis.auditRoleAssign.title': '角色授权报表',
  'pages.analysis.auditRoleAssign.pleaseSelectRole': '请先选择角色',
  'pages.analysis.auditRoleAssign.authData': '授权数据',

  // ── 角色权限详情 (audit/role-detail) ────────────────────
  'pages.analysis.auditRoleDetail.title': '角色权限详情',
  'pages.analysis.auditRoleDetail.loadRoleDetailFailed': '加载角色详情失败',
  'pages.analysis.auditRoleDetail.loadMenuPermFailed': '加载菜单权限失败',
  'pages.analysis.auditRoleDetail.btnQuery': '查看',
  'pages.analysis.auditRoleDetail.btnEdit': '编辑',
  'pages.analysis.auditRoleDetail.btnDelete': '删除',
  'pages.analysis.auditRoleDetail.btnAdd': '新增',
  'pages.analysis.auditRoleDetail.btnExport': '导出',
  'pages.analysis.auditRoleDetail.btnPrint': '打印',
  'pages.analysis.auditRoleDetail.roleName': '角色名称',
  'pages.analysis.auditRoleDetail.roleId': '角色ID',
  'pages.analysis.auditRoleDetail.remark': '备注',
  'pages.analysis.auditRoleDetail.associatedCompany': '关联公司',
  'pages.analysis.auditRoleDetail.searchPlaceholder': '输入菜单名称或权限码搜索',
  'pages.analysis.auditRoleDetail.roleInfo': '角色信息',
  'pages.analysis.auditRoleDetail.pleaseSelectRole': '请选择角色',
};
